import type { ReactNode } from "react";

import { EntityHoverTargetView } from "@/components/content/entity-card";

/** Who a person, the Twin or an API key is, from the workspace's own directory. */
export type ActorIdentity =
  | { kind: "person"; userId: string | null; name: string; imageUrl?: string | null }
  | { kind: "twin" }
  | { kind: "apiKey"; label: string };

/** What an actor's card is called, on the name or avatar it opens from. */
export function actorHoverLabel(actor: ActorIdentity): string {
  const name =
    actor.kind === "person" ? actor.name : actor.kind === "twin" ? "Twin" : actor.label;
  return `${name}: details`;
}

/**
 * An actor's name or avatar as ActorHover renders it closed: the target its
 * card opens from, with the attributes useEntityPopover gives a closed target
 * and no card. A surface without the workspace directory renders this.
 */
export function ActorHoverView({
  actor,
  className,
  children,
}: {
  actor: ActorIdentity;
  className?: string;
  children: ReactNode;
}) {
  return (
    <EntityHoverTargetView
      label={actorHoverLabel(actor)}
      aria-haspopup="dialog"
      aria-expanded={false}
      className={className}
    >
      {children}
    </EntityHoverTargetView>
  );
}
